<template>
  <div class="audioBox">
    <div v-for="(item, index) in num"
         :key="index"
         :class="'audio' + item + ' ' + 'wave' + item"
         :style="'background: ' + color + '; margin-right:' + marginright + 'px'"
    ></div>
  </div>
</template>

<script>


export default {
  name: "voice",

  props:{
    wave:{
      type: Boolean,
      default: false
    },
    color:{
      type:String,
      default(){
        return ""
      }
    },
    quantity:{
      type: Number,
      default: 131
    },

    marginright:{
      type: Number,
      default: 2
    }
  },

  data(){
    return {
      num: null
    }
  },
  mounted(){
    const splitToDigit = n => (n + '').split('').map(Number)
    this.num = splitToDigit(this.quantity)
  }
}
</script>

<style lang="less" scoped>

  .audioBox{
    height: 30px;
    display: flex;
    align-items: center;

    .audio1{
      width: 2px;
      height: 33.3%;
      //background: #000;
      border-radius: 50px;
    }

    .audio2{
      width: 2px;
      height: 55%;
      //background: #000;
      border-radius: 50px;
    }

    .audio3{
      width: 2px;
      height: 100%;
      //background: #000;
      border-radius: 50px;
    }
  }

  .audioplaying{
    .wave1 {
      @keyframes wave1 {
        0% {
          width: 2px;
          height: 33%;
        }
        25% {
          width: 2px;
          height: 66%;
        }
        50% {
          width: 2px;
          height: 100%;
        }
        75% {
          width: 2px;
          height: 66%;
        }
        100% {
          width: 2px;
          height: 33%;
        }
      }
      animation: wave1 1s linear 0s infinite;
    }

    .wave2 {
      @keyframes wave2 {
        0% {
          width: 2px;
          height: 66%;
        }
        25% {
          width: 2px;
          height: 33%;
        }
        50% {
          width: 2px;
          height: 66%;
        }
        75% {
          width: 2px;
          height: 100%;
        }
        100% {
          width: 2px;
          height: 66%;
        }

      }
      animation: wave2 1s linear 0s infinite;
    }

    .wave3 {
      @keyframes wave3 {
        0% {
          width: 2px;
          height: 100%;
        }
        50% {
          width: 2px;
          height: 33%;
        }
        100% {
          width: 2px;
          height: 100%;
        }
      }
      animation: wave3 1s linear 0s infinite;
    }
  }


</style>
